import { module as ModuleJS } from "modujs";

// swiper core styles
import "swiper/css";

// modules styles
import "swiper/css/navigation";
import "swiper/css/pagination";

import Swiper, { Navigation, Pagination, SwiperOptions } from "swiper";

// Snapshot tailwind config with babel-plugin-preval
const tailwindScreens = preval`
    const resolveConfig = require('tailwindcss/resolveConfig');
    const tailwindConfig = require('./../../../tailwind.config.js');

    const fullConfig = resolveConfig(tailwindConfig)
    module.exports = fullConfig.theme.screens;
`;

export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.slides = this.$("slide");
        this.prevEl = this.$("prev")[0];
        this.nextEl = this.$("next")[0];
        this.paginationEl = this.$("pagination")[0];

        /** @type {SwiperOptions} */
        this.config = {};
    }

    init() {
        this.onInit = this.onInit.bind(this);
        this.onResize = this.onResize.bind(this);
        this.toggleNavigationBySize = this.toggleNavigationBySize.bind(this);

        new Swiper(this.el, {
            grabCursor: true,
            direction: "horizontal",
            modules: [Navigation, Pagination],

            // Navigation arrows
            navigation: {
                nextEl: this.nextEl,
                prevEl: this.prevEl,
            },

            pagination: {
                el: this.paginationEl,
                type: "bullets",
            },

            on: {
                init: this.onInit,
                resize: this.onResize,
            },

            ...this.config,
        });
    }

    onInit() {
        this.toggleNavigationBySize();
    }

    onResize() {
        this.toggleNavigationBySize();
    }

    toggleNavigationBySize() {
        const navigationBreakpoint = parseInt(tailwindScreens.md);
        this.el.classList.toggle('-navigation-disabled', window.innerWidth < navigationBreakpoint);
    }

    bindEvents(el) {}

    update(newContainer) {}

    destroy(oldContainer) {}
}
